<template>
  <div class="common-detail">
    <div class="title">{{detail.title}}</div>
    <div class="detail" v-if="detailShow">
      <span>添加时间:{{detail.add_time | parseTime('{y}-{m}-{d}')}}</span>
      <span>作者:{{detail.issuer}}</span>
      <span>来源:国家海洋标准计量中心</span>
      <span>阅读次数:{{detail.views}}</span>
    </div>
    <div class="article-content ql-editor" v-html="detail.content">

    </div>
    <!-- <h3 v-show="detail.file_url1 !=''">附件下载：</h3> -->
    <p class="down" v-for="(item,index) in detail.file_url1" :key='index'>
      <a :href="item.url">{{index + 1}}、{{item.name}}</a>
    </p>
  </div>
</template>
<script>

export default {
  data() {
    return {
    };
  },
props: {
    detail: {
      type: Object,
      default: Array
    },
    detailShow: {
      type: Boolean,
      default: true
    }
  },
  // props: ["detail"]
};
</script>

<style scoped>
.common-detail .title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
  line-height: 35px;
}
.common-detail .detail {
  font-size: 0;
  text-align: center;
  margin-bottom: 30px;
}
.common-detail .detail > span {
  font-size: 14px;
  margin: 0 10px;
}
.article-content {
  font-size: 16px;
  line-height: 30px;
}
.article-content /deep/ p {
  /* margin-bottom: 20px; */
}
.article-content /deep/ img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}
.down{
  width:100%;
  padding:20px 50px 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/views/common/itemDetail.vue